import XLSX from "xlsx";

export function jsonDataToExcel(data, filename) {
    let dataWS = XLSX.utils.json_to_sheet(data);
    let wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, dataWS, 'data');

    filename = filename ? filename : 'data.xlsx'
    XLSX.writeFile(wb, filename);
}

export function multipleJsonDataToExcel(dataOne, dataTwo) {
    let worksheet_tmp1 = XLSX.utils.json_to_sheet(dataOne);
    let worksheet_tmp2 = XLSX.utils.json_to_sheet(dataTwo);

    let a = XLSX.utils.sheet_to_json(worksheet_tmp1, {header: 1});
    let b = XLSX.utils.sheet_to_json(worksheet_tmp2, {header: 1});

    a = a.concat(['']).concat(b);
    let worksheet = XLSX.utils.json_to_sheet(a, {skipHeader: true});

    const new_workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(new_workbook, worksheet, "worksheet");
    XLSX.writeFile(new_workbook, 'order.xlsx')
}
